/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TokenPaymentMethod } from './TokenPaymentMethod';
import {
    TokenPaymentMethodFromJSON,
    TokenPaymentMethodFromJSONTyped,
    TokenPaymentMethodToJSON,
    TokenPaymentMethodToJSONTyped,
} from './TokenPaymentMethod';

/**
 * 
 * @export
 * @interface FuelPurchaseRequestBody
 */
export interface FuelPurchaseRequestBody {
    /**
     * 
     * @type {TokenPaymentMethod}
     * @memberof FuelPurchaseRequestBody
     */
    paymentMethod?: TokenPaymentMethod;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchaseRequestBody
     */
    xp?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchaseRequestBody
     */
    fuel?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchaseRequestBody
     */
    fiat?: number;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchaseRequestBody
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FuelPurchaseRequestBody
     */
    commit?: boolean;
}



/**
 * Check if a given object implements the FuelPurchaseRequestBody interface.
 */
export function instanceOfFuelPurchaseRequestBody(value: object): value is FuelPurchaseRequestBody {
    return true;
}

export function FuelPurchaseRequestBodyFromJSON(json: any): FuelPurchaseRequestBody {
    return FuelPurchaseRequestBodyFromJSONTyped(json, false);
}

export function FuelPurchaseRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelPurchaseRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['paymentMethod'] == null ? undefined : TokenPaymentMethodFromJSON(json['paymentMethod']),
        'xp': json['xp'] == null ? undefined : json['xp'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'fiat': json['fiat'] == null ? undefined : json['fiat'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'commit': json['commit'] == null ? undefined : json['commit'],
    };
}

export function FuelPurchaseRequestBodyToJSON(json: any): FuelPurchaseRequestBody {
    return FuelPurchaseRequestBodyToJSONTyped(json, false);
}

export function FuelPurchaseRequestBodyToJSONTyped(value?: FuelPurchaseRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethod': TokenPaymentMethodToJSON(value['paymentMethod']),
        'xp': value['xp'],
        'fuel': value['fuel'],
        'fiat': value['fiat'],
        'paymentMethodId': value['paymentMethodId'],
        'commit': value['commit'],
    };
}

